import GameBaseState from "./GameBaseState";
import Logger from "@js/logger";
import * as Accounts from "@js/account";
import { IStateType } from "./IGameState";
import { isGameHtml } from "@/js/utils";
import CheckIfExistGamingWindow from "@js/checkGameingWindow";
import { Modal } from "ant-design-vue";
import { yunpb } from "@/types/protobuf";
export default class GameStateCanReturnGame extends GameBaseState {
  private playerStatusData;
  private myType = IStateType.CAN_RETURN_GAME;
  constructor() {
    super();
    this.playerStatusData = this.playGameStore.playerStatusData;
  }
  async onPageReload() {
    Logger.log(`GameState ${IStateType[this.myType]} onPageReload`);

    const { node } = this.playerStatusData;
    node?.id && Accounts.setGameUid(node.id);
    node && Accounts.setCurrentGameNode(node);

    this.playGameStore.isQueueing = false;
    const exist: boolean =
      await CheckIfExistGamingWindow.checkIfExistGamingWindow();
    Accounts.setCurrentGame(this.playerStatusData.gameNode!);
    if (isGameHtml()) return;

    if (exist) {
      Logger.log(`GameState ${IStateType[this.myType]} exist GameingWindow`);
      this.playGameStore.showFloatModal({
        playerOper: this.PLAYERSTATUS.NO_OPER,
      });
    } else {
      Logger.log(
        `GameState ${IStateType[this.myType]} does not exist GameingWindow`
      );
      if (this.playGameStore.isFirstLoadGameNotOver) {
        this.playGameStore.isFirstLoadGameNotOver = false;
        // 只有进入首页刷新
        Modal.confirm({
          title: "Tips",
          content: "Your game is not over. Do you want to continue the game?",
          okText: "Continue",
          cancelText: "Cancle",
          centered: true,
          onOk: () => {
            Logger.log(`GameState ${IStateType[this.myType]} continue game`);
            this.playGameStore.isFirstLoadGameNotOver = true;
            return new Promise((resolve, reject) => {
              this.playGameStore.handleOpenGame().then((res) => resolve(res));
            });
          },
          onCancel: () => {
            Logger.log(`GameState ${IStateType[this.myType]} exit game`);
            this.playGameStore.isFirstLoadGameNotOver = true;
            this.exitGame();
          },
        });
      }
    }
  }
  /**
   * 游戏中切换游戏有两种情况
   * 点击同一个游戏，直接打开游戏窗口
   * 不同游戏 弹窗是否切换游戏的确认窗
   */
  playGame(game?: yunpb.IGetGameRoomInfoRsp | null) {
    Logger.log(`GameState ${IStateType[this.myType]} playGame`);
    Accounts.setSelectGame(game as yunpb.IGameNode);
    const playingGame: pro.yunpb.IGameNode = Accounts.getCurrentGame();
    if (!game) {
      this.showToastMessage("Missing game parameters");
      return;
    }
    if (!playingGame) {
      this.reQueueGame();
      return;
    }
    if (!Accounts.gameEqual(playingGame, game.gameBaseInfo!)) {
      this.playGameStore.showExitModal({
        from: playingGame.name,
        to: game.gameBaseInfo?.gameName,
      });
    } else {
      // 直接打开游戏
      this.playGameStore.handleOpenGame();
    }
  }
  // 退出游戏
  exitGame() {
    Logger.log(`GameState ${IStateType[this.myType]} exitGame`);
    this.playGameStore
      .handleGameExit()
      .then(() => (this.playGameStore.isExiting = false));
    this.setState(IStateType.FREE);
  }
}
